import * as React from "react"
import Login from "../components/login/page"
import crispChatInit from "../utils/crisp"
import GlobalStateContext, { GlobalStateProvider } from "../components/general/globalState"
import { Head } from "../components/general/head"
import getTranslationString from '../components/general/translateToString'

const LoginPageContent = () => {
  const { language } = React.useContext(GlobalStateContext)

  React.useEffect(() => {
    crispChatInit()
  }, [])

  const title = getTranslationString('login.tryItNow', 'pages', 'login', language)
  const description = getTranslationString('login.createAccountDescription', 'pages', 'login', language)

  return (
    <main>
      <Head 
        title={title} 
        description={description}
        image={"https://podsqueeze.com/homepageog.jpg"}
        href="https://podsqueeze.com/login/"
        isNoIndex={false}
      />
      <Login/>
    </main>
  )
}

const LoginPage = () => (
  <GlobalStateProvider>
    <LoginPageContent />
  </GlobalStateProvider>
)

export default LoginPage